import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '@/api/axios'
import { SELECT_PUESTOS } from '@/utils/constants'

export const useTurnosStore = defineStore('turnos', () => {
  const users = ref([])
  const turnos = ref([])
  const timeSlots = ref([])
  const timeSlotsPuesto = ref([
    {
      puesto: 1,
      slots: [
        { id: 'mañana_hc', name: 'MAÑANA', color: '#6699FF' },
        { id: 'mañana_hp', name: 'MAÑANA', color: '#999900' },
        { id: 'tarde_hc', name: 'TARDE', color: '#6699FF' },
        { id: 'tarde_hp', name: 'TARDE', color: '#999900' },
        { id: 'noche_hc', name: 'NOCHE', color: '#6699FF' },
        { id: 'noche_hp', name: 'NOCHE', color: '#999900' },
        { id: 'despacho', name: 'despacho', color: '#dffcc4ff' },
        { id: 'sob', name: 'sob', color: '#80FFFF' },
        { id: 'vac', name: 'vac', color: '#A16252' },
        { id: 'baja', name: 'baja', color: '#A1A100' },
        { id: 'fiesta', name: 'fiesta', color: '#df8e8e' },
        { id: 'permiso', name: 'permiso', color: '#d16fff' },
        { id: 'papelera', name: 'papelera', color: '#f57c8eff' }
      ]
    },
    {
      puesto: 2,
      slots: [
        { id: '3ero', name: '3ero', color: '#7676ff' },
        { id: '2do', name: '2do', color: '#7676ff' },
        { id: '1ro', name: '1ro', color: '#7676ff' },
        { id: 'Coc_hc ', name: 'COC', color: '#7676ff' },
        { id: 'A_cocina_hb', name: 'A COCINA', color: '#7676ff' },
        { id: 'Lavanderia_hc ', name: 'LAVANDERIA', color: '#7676ff' },
        { id: 'Platos_hc', name: 'PLATOS', color: '#7676ff' },
        { id: 'Botones_hc', name: 'BOTONES', color: '#7676ff' },
        { id: 'Fondos_hc', name: 'FONDOS', color: '#7676ff' },

        { id: 'Dam', name: 'DAM', color: '#bd8b28' },
        { id: 'Sol', name: 'SOL', color: '#bd8b28' },
        { id: 'Coc_hp', name: 'COC', color: '#bd8b28' },
        { id: 'A_cocina_hp', name: 'A COCINA', color: '#bd8b28' },
        { id: 'Lav/Buffet_hp', name: 'LAV/BUFFET', color: '#bd8b28' },
        { id: 'Botones_hp', name: 'BOTONES', color: '#bd8b28' },
        { id: 'Fondos_hp', name: 'FONDOS', color: '#bd8b28' },
        { id: 'Obras_hp', name: 'OBRAS', color: '#bd8b28' },
        { id: 'Obras2_hp', name: 'OBRAS 2', color: '#bd8b28' },
        { id: 'sob', name: 'sob', color: '#80FFFF' },
        { id: 'vac', name: 'vac', color: '#A16252' },
        { id: 'baja', name: 'baja', color: '#A1A100' },
        { id: 'fiesta', name: 'fiesta', color: '#df8e8e' },
        { id: 'permiso', name: 'permiso', color: '#d16fff' },
        { id: 'papelera', name: 'papelera', color: '#f57c8eff' }
      ]
    }
  ])

  // const fetchTimeSlots = async () => {
  //   const { data } = await api.get('/turnos/time-slots')
  //   timeSlots.value = data
  // }

  const months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ]

  const setTimeSlotsPuesto = (puesto) => {
    console.log('setTimeSlotsPuesto ', puesto)
    // Convertir puesto a número si viene como string
    const puestoId = parseInt(puesto, 10)

    // Buscar el timeSlot que corresponde al puesto
    const ts = timeSlotsPuesto.value.find((slot) => slot.puesto === puestoId)

    // Reiniciar timeSlots
    timeSlots.value = []

    // Si se encontró el puesto, asignar sus slots
    if (ts) {
      timeSlots.value = ts.slots
      console.log('Slots asignados para puesto', puestoId, timeSlots.value)
    } else {
      console.warn(`No se encontraron slots para el puesto ${puestoId}`)
    }
  }

  const fetchTurnos = async (puesto = SELECT_PUESTOS[0].value, fecha) => {
    try {
      const formattedDate =
        fecha instanceof Date
          ? `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(
              2,
              '0'
            )}-${String(fecha.getDate()).padStart(2, '0')}`
          : fecha

      const { data } = await api.get(`/turnos/${puesto}/${formattedDate}`)
      const { Items, Users, msgError } = data

      if (msgError) {
        console.error('Error al obtener turnos:', msgError)
        throw new Error(msgError)
      }

      // Procesar los Items para crear un objeto estructurado por fecha y turno
      const processedTurnos = {}
      if (Items && Items.length > 0) {
        Items.forEach((item) => {
          if (!processedTurnos[item.fecha]) {
            processedTurnos[item.fecha] = {}
          }
          if (!processedTurnos[item.fecha][item.turno]) {
            processedTurnos[item.fecha][item.turno] = []
          }
          // Encontrar la información del usuario
          const user = Users.find((u) => u.id === item.usuario_id)
          if (user) {
            // Asegurarse de que la propiedad prevision se incluya
            const userWithPrevision = {
              ...user,
              prevision: item.prevision || false
            }
            processedTurnos[item.fecha][item.turno].push(userWithPrevision)
          }
        })
      }

      if (Users && Users.length > 0) {
        users.value = Users
      }

      turnos.value = processedTurnos
      return processedTurnos
    } catch (error) {
      console.error('Error al obtener turnos:', error)
      throw error
    }
  }

  const fetchUserTurnos = async (userId, fecha) => {
    try {
      const formattedDate =
        fecha instanceof Date
          ? `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(
              2,
              '0'
            )}-${String(fecha.getDate()).padStart(2, '0')}`
          : fecha

      const { data } = await api.get(`/turnos/user/${userId}/${formattedDate}`)
      const { Items, Users, msgError } = data

      if (msgError) {
        console.error('Error al obtener turnos del usuario:', msgError)
        throw new Error(msgError)
      }

      // Procesar los Items para crear un objeto estructurado por fecha y turno
      const processedTurnos = {}
      if (Items && Items.length > 0) {
        Items.forEach((item) => {
          if (!processedTurnos[item.fecha]) {
            processedTurnos[item.fecha] = {}
          }
          if (!processedTurnos[item.fecha][item.turno]) {
            processedTurnos[item.fecha][item.turno] = []
          }
          // Encontrar la información del usuario
          const user = Users.find((u) => u.id === item.usuario_id)
          if (user) {
            // Asegurarse de que la propiedad prevision se incluya
            const userWithPrevision = {
              ...user,
              prevision: item.prevision || false
            }
            processedTurnos[item.fecha][item.turno].push(userWithPrevision)
          }
        })
      }

      if (Users && Users.length > 0) {
        users.value = Users
      }

      turnos.value = processedTurnos
      return processedTurnos
    } catch (error) {
      console.error('Error al obtener turnos del usuario:', error)
      throw error
    }
  }

  const saveTurnos = async (turnos) => {
    try {
      const { data } = await api.post('/turnos/bulk', { turnos })
      return data
    } catch (error) {
      console.error('Error al guardar turnos:', error)
      throw error
    }
  }

  async function getVacacionesPorMes(userId, year) {
    try {
      const response = await api.get(`/turnos/vacaciones/${userId}/${year}`)
      return response.data
    } catch (error) {
      console.error('Error fetching vacaciones:', error)
      throw error
    }
  }

  return {
    users,
    timeSlots,
    months,
    fetchTurnos,
    fetchUserTurnos,
    saveTurnos,
    getVacacionesPorMes,
    setTimeSlotsPuesto
  }
})
